import { C, S } from "../customers/theme";
import { DN_STATUSES } from "../lib/deliveryNotes";

const n3 = (x) => Math.round((Number(x) || 0) * 1000) / 1000;
const statusOf = (v) => DN_STATUSES.find((s) => s.value === v) || { label: v, color: C.textDim };
export function DNStatusBadge({ status }) {
  const s = statusOf(status);
  return <span style={S.pill(s.color)}>{s.label}</span>;
}

export default function DeliveryNoteView({ note, onClose, onEdit }) {
  const lines = (note.delivery_note_lines || []).slice().sort((a, b) => (a.position || 0) - (b.position || 0));
  const cust = note.customers || {};
  const so = note.sales_orders || {};
  const sum = lines.reduce((a, l) => ({ dispatched: a.dispatched + n3(l.dispatched_quantity), returned: a.returned + n3(l.returned_quantity), outstanding: a.outstanding + n3(l.outstanding_quantity) }), { dispatched: 0, returned: 0, outstanding: 0 });

  return (
    <div style={S.modal} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div style={{ ...S.modalBox, width: 900 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 6 }}>
          <div>
            <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700 }}>{note.dn_number}</h2>
            <div style={{ color: C.textMuted, fontSize: 13, marginTop: 3 }}>
              {note.customer_name || cust.company_name || "—"}{(note.sales_order_number || so.so_number) && ` · against ${note.sales_order_number || so.so_number}`}
            </div>
          </div>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <DNStatusBadge status={note.status} />
            <button onClick={() => onEdit(note)} style={S.btn()}>Edit</button>
            <button onClick={onClose} aria-label="Close" style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: C.textMuted }}>✕</button>
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18, marginTop: 14 }}>
          <div>
            <div style={S.sectionTitle}>Customer</div>
            <div style={{ fontSize: 13, lineHeight: 1.7 }}>
              <div><strong>{note.customer_name || cust.company_name || "—"}</strong></div>
              <div style={{ color: C.textMuted }}>Sales order: <span style={{ color: C.text }}>{note.sales_order_number || so.so_number || "—"}</span></div>
            </div>
          </div>
          <div>
            <div style={S.sectionTitle}>Dispatch</div>
            <div style={{ fontSize: 13, lineHeight: 1.7, color: C.textMuted }}>
              <div>Date: <span style={{ color: C.text }}>{note.delivery_date || "—"}</span></div>
              <div>Driver: <span style={{ color: C.text }}>{note.driver || "—"}</span></div>
              <div>Vehicle: <span style={{ color: C.text }}>{note.vehicle || "—"}</span></div>
              {note.reference && <div>Reference: <span style={{ color: C.text }}>{note.reference}</span></div>}
            </div>
          </div>
        </div>

        <div style={S.sectionTitle}>Items</div>
        <table style={S.table}>
          <thead><tr>
            {["Product", "SKU", "Ordered", "Reserved", "Dispatched", "Returned", "Outstanding"].map((h) => <th key={h} style={S.th}>{h}</th>)}
          </tr></thead>
          <tbody>
            {lines.length === 0 ? <tr><td colSpan={7} style={S.empty}>No lines</td></tr> : lines.map((l) => (
              <tr key={l.id}>
                <td style={S.td}>{l.description || "—"}</td>
                <td style={S.td}>{l.sku || "—"}</td>
                <td style={S.td}>{n3(l.ordered_quantity)}</td>
                <td style={S.td}>{n3(l.reserved_quantity)}</td>
                <td style={S.td}><strong style={{ color: C.success }}>{n3(l.dispatched_quantity)}</strong></td>
                <td style={S.td}>{n3(l.returned_quantity) > 0 ? <span style={{ color: C.warning }}>{n3(l.returned_quantity)}</span> : "—"}</td>
                <td style={S.td}><span style={{ color: n3(l.outstanding_quantity) > 0 ? C.warning : C.textMuted }}>{n3(l.outstanding_quantity)}</span></td>
              </tr>
            ))}
          </tbody>
        </table>

        <div style={{ display: "flex", gap: 18, flexWrap: "wrap", background: C.surface2, borderRadius: 8, padding: "10px 16px", marginTop: 12, fontSize: 13 }}>
          <span style={{ color: C.textMuted }}>Dispatched <strong style={{ color: C.success }}>{sum.dispatched}</strong></span>
          <span style={{ color: C.textMuted }}>Returned <strong style={{ color: sum.returned > 0 ? C.warning : C.text }}>{sum.returned}</strong></span>
          <span style={{ color: C.textMuted }}>Outstanding <strong style={{ color: sum.outstanding > 0 ? C.warning : C.success }}>{sum.outstanding}</strong></span>
        </div>

        {note.notes && (<><div style={S.sectionTitle}>Notes</div><div style={{ fontSize: 13, whiteSpace: "pre-wrap" }}>{note.notes}</div></>)}
      </div>
    </div>
  );
}
